import React from 'react';
import { ClipboardCheckIcon, CompassIcon, LibraryIcon, ShieldIcon, ZapIcon } from 'lucide-react';
import { SectionLabel } from '../SectionLabel';
import { CtaButton } from '../CtaButton';
import { deliveryItems } from '../../data/content';
const icons = [LibraryIcon, CompassIcon, ShieldIcon, ZapIcon, ClipboardCheckIcon];
export function Delivery() {
  return <section className="w-full bg-navy-deep px-4 py-12 sm:px-6 sm:py-20" data-id="element-174" data-mp="1e3p28g7hpsrv">
      <div className="mx-auto max-w-4xl" data-id="element-175" data-mp="1e5i99wm0mf0e">
        <div className="text-center" data-id="element-176" data-mp="1j28oyitwr8la">
          <SectionLabel tone="dark" data-id="element-177" data-mp="1j3beonfhv4zm">Consegna immediata</SectionLabel>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-[1.15] text-white sm:text-4xl md:text-[42px]" data-id="element-178" data-mp="1o1lan091m9ma">
            Cosa riceverai subito dopo il tuo acquisto?
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-[15px] leading-relaxed text-white/70 sm:text-lg" data-id="element-179" data-mp="vdpdxvjh4hpi">
            Dal primo minuto avrai a disposizione un sistema completo di supporto alle
            decisioni cliniche, pronto per la tua prossima visita.
          </p>
        </div>

        <ul className="mt-8 grid gap-4 sm:mt-12 sm:grid-cols-2 sm:gap-5" data-id="element-180" data-mp="rmbapb1pxdxt">
          {deliveryItems.map((item, index) => {
          const Icon = icons[index] ?? LibraryIcon;
          return <li key={item.id} className={`flex flex-col rounded-2xl border border-white/10 bg-white/[0.05] p-5 sm:p-6 ${index === 0 ? 'sm:col-span-2' : ''}`} data-id="element-181" data-mp="itzj3luvbkg9" data-mpi={index}>
                <Icon className="h-6 w-6 shrink-0 text-kidney-bright" aria-hidden="true" data-id="element-182" data-mp="8tyxft9j0s8w" />
                <h3 className="mt-3.5 font-display text-[19px] font-bold leading-snug text-white sm:text-[22px]" data-id="element-183" data-mp="3w09g5tobgxnw">
                  {item.title}
                </h3>
                <div className="mt-2.5 flex flex-col gap-2" data-id="element-184" data-mp="1y9oy50o58t6l">
                  {item.lines.map(line => <p key={line} className="text-[14px] leading-relaxed text-white/70" data-id="element-185" data-mp="1u6s8wr43lyto">
                      {line}
                    </p>)}
                </div>
              </li>;
        })}
        </ul>

        <div className="mt-8 text-center sm:mt-12" data-id="element-186" data-mp="3eougqw94crma">
          <p className="text-[15px] leading-relaxed text-white/70 sm:text-lg" data-id="element-187" data-mp="3itkb2go4py53">
            Qualsiasi paziente con malattia renale che entrerà nel tuo studio…
          </p>
          <p className="mt-1.5 font-display text-[20px] font-bold text-kidney-bright sm:text-2xl" data-id="element-188" data-mp="fbjzysna1cn9">
            Ora avrà un percorso clinico chiaro.
          </p>
        </div>

        <div className="mx-auto mt-7 max-w-md sm:mt-9" data-id="element-189" data-mp="1edir2i7bm05">
          <CtaButton tone="cream" label="Voglio il mio sistema decisionale" sub="Algoritmi, protocolli, percorsi e checklist — tutto in un unico sistema." data-id="element-190" data-mp="6a2ip6y4v4wz" />
        </div>
      </div>
    </section>;
}